import { render, staticRenderFns } from "./PricesServiceList.vue?vue&type=template&id=ec567e68&"
import script from "./PricesServiceList.vue?vue&type=script&lang=ts&setup=true&"
export * from "./PricesServiceList.vue?vue&type=script&lang=ts&setup=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/prodoctorov/pd-ssr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec567e68')) {
      api.createRecord('ec567e68', component.options)
    } else {
      api.reload('ec567e68', component.options)
    }
    module.hot.accept("./PricesServiceList.vue?vue&type=template&id=ec567e68&", function () {
      api.rerender('ec567e68', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuPrices/components/PricesServiceList.vue"
export default component.exports